import LinkTile from './LinkTile';
export default LinkTile;